export default __webpack_public_path__ + "static/media/dribble.fe21353d.png";